import { ApiService } from '@shared/api';

class ProductService extends ApiService {
  // eslint-disable-next-line
  constructor(props) {
    super(props);

    this.baseUrl = '/products'; 
  }

  async getProduct(userId) {
    return await this.instance.get(`${this.baseUrl}/${userId}`);
  }

  async patreon() {
    return await this.instance.get(`${this.baseUrl}/patreon`);
  }

  async getPatreonOuath() {
    return await this.instance.get(`${this.baseUrl}/patreon/oauth/redirect`);
  }

  async getPatreonMember(userId) {
    return await this.instance.get(`${this.baseUrl}/patreon/members/${userId}`);
  }

  async getPlugin(type) {
    return await this.instance.post(`${this.baseUrl}/plugin/get`, {type},
      { responseType: "blob" }
    );
  }

  async getPluginInfo() {
    return await this.instance.get(`${this.baseUrl}/plugin/info`);
  }

  async getBriefs() {
    return await this.instance.get(`${this.baseUrl}/get-canva`);
  }

  async getAdobeRating(params) {
    return await this.instance.get(`${this.baseUrl}/adobe/get-rating?${this.generateQueryString(params)}`);
  }

  async getAdobeRatingHistory(id) {
    return await this.instance.get(`${this.baseUrl}/adobe/rating-history/${id}`);
  }
}

const productService = new ProductService();

export default productService;
